<template>
  <div class="head-page">
    <Header
      :title="$t('register.login')"
      :isreturn="true"
      :iconurl="-1"
      :iconkey="'service-o'"
    />
    <div class="login-icon-box">
      <img :src="safeWapConfig.logo" />
    </div>
    <van-form
      ref="frm"
      @submit="onSubmit"
      style="width: 96%; margin: 10px auto"
    >
      <van-field
        v-model="frm.username"
        :placeholder="$t('register.accountplaceholder')"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="frm.password"
        type="password"
        :placeholder="$t('register.pwdplaceholder')"
        :rules="[{ required: true }]"
      />
      <van-field name="checkboxGroup">
        <template #input>
          <van-checkbox-group v-model="checkboxGroup">
            <van-checkbox name="1" shape="square" icon-size="16px">{{
              $t('register.remember')
            }}</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button native-type="submit" class="web-btn">
          <van-loading v-if="posting" /><span v-else>{{
            $t('register.login')
          }}</span></van-button
        >
      </div>
    </van-form>

    <van-row style="padding: 10px 20px; font-size: 14px">
      <van-col :span="12">
        <router-link class="link-btn" :to="'/register'">{{
          $t('register.register')
        }}</router-link>
      </van-col>
      <van-col :span="12" class="txt-right link-btn">
        <span @click="jumpUrl(safeWapConfig.custom_service)">{{
          $t('register.fotget')
        }}</span>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Header from '@/components/Header'
import {
  setToken,
  getToken,
  setTokenbyName,
  getTokenbyName,
  TokenAccount
} from '@/utils/cookies'
export default {
  name: 'LoginView',
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  components: { Header },
  data () {
    return {
      posting: false,
      checkboxGroup: [],
      frm: {
        username: null,
        password: null,
        ip:null
      }
    }
  },
  mounted () {
    if (getToken()) {
      this.$router.push({ name: 'home' })
      return
    }
    const tmpfrm = getTokenbyName(TokenAccount)
    if (tmpfrm) {
      this.frm = tmpfrm
      this.checkboxGroup = ['1']
    }
    this.getPublicIP()
  },
  methods: {
    async getPublicIP () {
      try {
        const response = await fetch('https://api.ipify.org?format=json')
        const data = await response.json()
        this.frm.ip = data.ip
      } catch (error) {
        console.log(error)
      }
    },
    jumpUrl (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
      /*
      const _u = navigator.userAgent;
      const ios = _u.indexOf("iPhone") > -1;
      const iPad = _u.indexOf("iPad") > -1;
      if (ios || iPad) {
        window.location.replace(url);
      } else {
        if (url.includes("https://")) {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
        */
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true
      if (this.type == 0) this.frm.email = this.tmp
      else this.frm.phone = this.tmp
      await this.$http({
        method: 'post',
        url: 'login',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          if (this.checkboxGroup && this.checkboxGroup.length > 0) {
            setTokenbyName(TokenAccount, this.frm)
          }
          setToken(res.data.userinfo.token)
          location.reload()
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>

<style></style>
